const PHRASES = [
  "Reading",
  "Writing",
  "Debate",
  "Film & Media",
  "Wellbeing",
  "EduPower13",
  "English is Lekka",
  "Your Story Matters",
];

const Spark = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" className="fill-sand shrink-0" aria-hidden="true">
    <path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8L12 2z" />
  </svg>
);

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div
      className="marquee-paused overflow-hidden bg-ember py-6"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max items-center gap-12">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-12">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-12">
                <span className="font-display font-bold uppercase tracking-[0.12em] text-sand text-xl sm:text-2xl whitespace-nowrap">
                  {p}
                </span>
                <Spark />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
